export const createGtmEventsProxy = (gtmEvents = {}) => new Proxy(gtmEvents, {
  get(target, prop) {
    // если свойство строковое значение (например: не symbol) и свойства нет в списке событий
    if (typeof prop === 'string' && !target[prop]) {
      return () => {}; // возвращаем пустую функцию, чтобы не было ошибок
    }

    // нужно чтобы this в методе был списком событий (target), а не прокси
    // чтобы мы лишний раз не заходили в прокси
    if (typeof target[prop] === 'function') return target[prop].bind(target);

    return target[prop];
  },
});
